<h2 mat-dialog-title>Save As</h2>

<mat-dialog-content>
  <mat-form-field appearance="fill" class="fullwidth">
    <mat-label>File Name</mat-label>
    <input matInput [formControl]="nameForm">
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button (click)="close()">Close</button>
  <button mat-button color="primary" [disabled]="nameForm.invalid" (click)="save()">Save</button>
</mat-dialog-actions>
